import { takeEvery } from 'redux-saga'

import actions from 'actions'
import { homeLoadPage, homeLoadPastEventGroups } from './home-sagas'

export function* watchHomeLoadPage() {
  yield* takeEvery(actions.HOME_LOAD_PAGE, homeLoadPage)
}

export function* watchHomeLoadPastEventGroups() {
  yield* takeEvery(actions.HOME_LOAD_PAST_EVENT_GROUPS, homeLoadPastEventGroups)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/home/home-watchers.js
 **/